import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

import { ClientDocumentModel } from '../../model';

@Injectable({
  providedIn: 'root',
})
export class ClientDocumentService {
  constructor(private http: HttpClient) {}

  public getUserDocuments(
    clientId: string,
    type: (
      | 'DRIVERS_LICENSE_FRONT'
      | 'DRIVERS_LICENSE_BACK'
      | 'ID_CARD_FRONT'
      | 'ID_CARD_BACK'
      | 'PASSPORT'
      | 'INSURANCE'
      | 'OTHER'
    )[],
  ): Observable<ClientDocumentModel[]> {
    const params = new HttpParams().set('type', type.join(','));

    return this.http.get<ClientDocumentModel[]>(`${environment.apiEndpoint}/account/client-document/${clientId}`, {
      params,
    });
  }

  public getUploadUrlForDocument(
    clientId: string,
    type: (
      | 'DRIVERS_LICENSE_FRONT'
      | 'DRIVERS_LICENSE_BACK'
      | 'ID_CARD_FRONT'
      | 'ID_CARD_BACK'
      | 'PASSPORT'
      | 'INSURANCE'
      | 'OTHER'
    )[],
  ): Observable<string> {
    return this.http.post(`${environment.apiEndpoint}/account/client-document/${clientId}/${type}`, null, {
      responseType: 'text',
    });
  }

  public uploadUserDocument(url: string, file: File): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': file.type,
      'x-amz-acl': 'private',
      'Content-Disposition': `attachment; filename="${file.name}"`,
    });

    return this.http.put(url, file, { headers, observe: 'response', responseType: 'text' });
  }

  public deleteUserDocument(clientId: string, documentId: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiEndpoint}/account/client-document/${clientId}/${documentId}`);
  }
}
